export const TEST_IDS = {
  map: {
    markerLabel: 'map-marker-label',
  },
  toghol: {
    icon: 'toghol_icon',
    featuresButton: 'toghol_features-button',
    submitFeature: 'toghol_submit-feature',
    featureItem: 'toghol_feature-item',
  },
  layout: {
    mapLoadingSpinner: 'layout_map-loading-spinner',
    fetchLoading: 'layout_fetch-loading',
    bottomSheetHeaderCloseButton: 'bottomsheet-header-close',
    appLoadingSpinner: 'app-loading-spinner',
    toggle: 'toggle',
    backButton: 'layout_header_back-button',
  },
  auth: {},
  newDeliveryRequest: {
    preview: {
      submit: 'new-delivery-request_preview_submit',
      simultaneousDeliveryBottomSheet: 'new-delivery-request_preview_simultaneous-delivery-bottom-sheet',
      deliveryOptions: {
        deliveryOptionsButton: 'new-delivery-request_preview_delivery-options-button',
        deliveryOptionsModal: 'new-delivery-request_preview_delivery-options-modal',
      },
    },
    receiver: {
      backButton: 'new-delivery-request_receiver_back-button',
    },
    checkout: {
      onlinePayment: 'new-delivery-request_checkout_online-payment',
      offlinePaymentToggle: 'new-delivery-request_checkout_offline-payment-toggle',
      submit: 'new-delivery-request_checkout_submit',
      courierNote: 'new-delivery-request_checkout_courier-note',
    },
    partySuggestion: {
      wrapper: 'new-delivery-request_party-suggestion_wrapper',
      chip: 'new-delivery-request_party-suggestion_chip',
    },
  },
  transceivers: {
    transceiverName: 'delivery-request_transceivers_transceiver-name',
    transceiverAddress: 'delivery-request_transceivers_transceiver-address',
    addNewReceiverButton: 'new-delivery-request_preview_delivery-options-add-new-receiver-button',
  },
  history: {
    list: {
      lastItem: 'history_list_last-item',
      item: 'history_list_item',
    },
    historyIcon: 'history_history-icon',
    reportCta: 'history_report-cta',
    detail: {
      courier: 'history_detail_courier',
      tryAgain: 'history_detail_try-again',
    },
  },
  homepage: {
    list: 'homepage_list',
    listBottom: 'homepage_list-bottom',
    deliveryRequestItem: 'homepage_delivery-request-item',
    deliveryRequestIcon: 'homepage_delivery-request-item_icon',
    deliveryRequestIconLoading: 'homepage_delivery-request-item_icon_loading',
    deliveryRequestItemStatus: 'homepage_delivery-request-item_status',
  },
  deliveryRequest: {
    trackLink: {
      generateTrackLinkButton: 'delivery-request_generate-track-link-button',
      generateTrackLinkSubmitButton: 'delivery-request_generate-track-link-submit-button',
      generateTrackLinkOption: 'delivery-request_generate-track-link-option',
      generateTrackLinkBottomSheet: 'delivery-request_generate-track-link-bottom-sheet',
    },
    details: {
      receipt: 'delivery-request_details-receipt',
      hearingImpairedModal: 'delivery-request_details_hearing-impaired-modal',
    },
  },
  track: {
    errorPage: 'track_errorPage',
    deliveryRequestDetails: 'track_delivery-request-details',
  },
  rating: {
    rateCourierButton: 'rating_rate-courier-button',
    prompt: 'rating_prompt',
    modal: 'rating_modal',
    sliderWrapper: 'rating_slider-wrapper',
    ratingNumber: 'rating_number',
    badgeWrapper: 'rating_badge-wrapper',
    badgeItem: 'rating_badge-item',
    dotIndicator: 'rating_dot-indicator',
    commentButton: 'rating_comment-button',
    commentInput: 'rating_comment-input',
    commentSubmit: 'rating_comment-submit',
    reasonWrapper: 'rating_reason-wrapper',
    submitRating: 'rating_submit',
    reasonToggle: 'rating_reason-toggle',
  },
  selectLocation: {
    contactsList: {
      item: 'contact-list_item',
      itemTitle: 'contact-list_item-title',
      listEnd: 'contact-list_list-end',
    },
    contactForm: {
      modal: 'contact-form_modal',
      close: 'contact-form_close-button',
      name: 'contact-form_name',
      phoneNumber: 'contact-form_phone-number',
      address: 'contact-form_address',
      buildingNumber: 'contact-form_building-number',
      apartmentNumber: 'contact-form_apartment-number',
      submit: 'contact-form_submit',
      inputForm: 'contact-form_input-form',
      saveContactBottomsheet: 'save-contact-bottomsheet',
      saveAddressButton: 'save-address-button',
      saveContactButton: 'save-contact-button',
      saveContactName: 'save-contact-name',
    },
    locationForm: {
      submitLocationButton: 'submit-transceiver-location-button',
      submitLocationButtonLoading: 'submit-transceiver-location-button-loading',
    },
  },
  discount: {
    discountCodeOpenButton: 'discount_discount-code-button',
    discountCodeInput: 'discount_discount-code-input',
    discountCodeSubmitButton: 'discount_discount-code-submit-button',
    incentiveItem: 'discount_incentive-item',
  },
  tooltip: {
    root: 'tooltip',
    dismiss: 'tooltip-dismiss',
  },
};
